import { Controller } from "@hotwired/stimulus"

// Billing period switch. Sets a single data-mode on the element; the CSS rules
//   [data-mode="monthly"] .mk-only-annual { display: none }
// do the rest, so there is no element list to keep in sync.
//
// Each button declares the mode it selects via data-mode. aria-pressed is synced
// by comparing that value, not by button position — reordering the buttons in a
// view would otherwise invert the pressed state silently.
//
// Markup:
//   <section data-controller="pricing-toggle" data-mode="monthly">
//     <button data-mode="monthly" aria-pressed="true"
//             data-action="click->pricing-toggle#monthly"
//             data-pricing-toggle-target="btn">Monthly</button>
//     <button data-mode="annual" aria-pressed="false"
//             data-action="click->pricing-toggle#annual"
//             data-pricing-toggle-target="btn">Yearly</button>
export default class extends Controller {
  static targets = ["btn"]

  monthly() { this.apply("monthly") }
  annual()  { this.apply("annual") }

  apply(mode) {
    this.element.dataset.mode = mode
    this.btnTargets.forEach((btn) => {
      btn.setAttribute("aria-pressed", String(btn.dataset.mode === mode))
    })
  }
}
